export default {
  state: {
    apiURL: '',
    tenantSetting: undefined,
    supportedCountries: [],
    psPreferredLanguageCode: '',
    defaultPageSize: 0,
    cashboxesCount: 0,
    activeMembersCount: undefined,
    images: {},
  },

  mutations: {
    changeAPIURL(state, payload) {
      state.apiURL = payload;
    },
    changeTenantSettings(state, payload) {
      state.tenantSetting = payload;
      state.defaultPageSize = (payload && payload.defaultPageSize) || 10;
    },
    updateTenantSettings(state, payload) {
      if (!payload) {
        return;
      }
      // Merge every saved field so the store stays in sync with Organization Settings
      // instead of enumerating fields, which kept drifting out of date.
      state.tenantSetting = { ...state.tenantSetting, ...payload };
      state.tenantSetting.defaultPageSize = payload.defaultPageSize || 10;
      // Keep the mirrored root-level page size in sync (read directly across the app).
      state.defaultPageSize = state.tenantSetting.defaultPageSize;
    },
    changeDefaultCurrency(state, currency) {
      state.tenantSetting = {
        ...state.tenantSetting,
        defaultCurrency: currency.id,
        currencyData: { id: currency.id, name: currency.name, shortcut: currency.shortcut },
      };
    },
    setSupportedCountries(state, payload) {
      state.supportedCountries = Array.isArray(payload) ? payload : [];
    },
    changeCashboxRequestCount(state, payload) {
      state.cashboxesCount = payload;
    },
    changeActiveMembersCount(state, payload) {
      state.activeMembersCount = payload;
    },
    updateImages(state, payload) {
      state.images = { ...state.images, [payload.id]: payload };
    },
  },
};
